import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/components/Home.css";
import { useLanguage } from "../../hooks/LanguageContext";

function Home() {
  const { isEnglish } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="home-content page-atmosphere">
      <div className="home-orb home-orb--one" aria-hidden="true" />
      <div className="home-orb home-orb--two" aria-hidden="true" />

      <div className="home-hero">
        <img
          src="/LOGO_BLANCO.png"
          alt="Miguel Olteanu"
          className="large-logo"
        />
        <h1 className="home-brand">Miguel Olteanu</h1>
        <p className="home-role">
          {isEnglish ? "Software Engineer" : "Ingeniero de Software"}
        </p>
        <div className="home-divider" aria-hidden="true" />
        <p className="motto">
          {isEnglish
            ? "Daily progress is the true engine of success."
            : "El progreso diario es el verdadero motor del éxito."}
        </p>
        <div className="home-actions">
          <button
            type="button"
            className="home-btn home-btn--primary"
            onClick={() => navigate("/projects")}
          >
            {isEnglish ? "View projects" : "Ver proyectos"}
          </button>
          <button
            type="button"
            className="home-btn home-btn--ghost"
            onClick={() => navigate("/about")}
          >
            {isEnglish ? "About me" : "Sobre mí"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Home;
